import styled from "styled-components";

export const Button = styled.div`
  position: relative;
  background: white;
  button {
    transform: translate(-2%, -8%);
    padding: 1.4rem 2.8rem;
    background: var(--primary-color);
    white-space: nowrap;
    &:hover {
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      transform: translate(-4%, -16%);
    }
  }
`;

export const IconWithBg = styled.button`
  background-color: var(--background-color);
  border-radius: 6px;
  height: 30px;
  min-width: 30px;
  max-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray-light-color);
  transition: all 0.15s ease-in-out;
  box-shadow: 1px 1px 2px var(--shadow);
  &:hover {
    transform: scale(1.1);
    background-color: var(--background-color);
  }
`;
